'use client'

import type React from 'react'

import { cn } from '@mntn-dev/ui-utilities'

type CenteredLayoutProps = Readonly<{
  children?: React.ReactNode
  className?: string
}>

const CenteredLayout = ({ children, className }: CenteredLayoutProps) => {
  return (
    <div className={cn('flex h-screen w-screen items-center justify-center')}>
      <main
        className={cn(
          'h-full w-fit-clamped flex flex-col items-center justify-center text-center',
          className
        )}
      >
        {children}
      </main>
    </div>
  )
}

export { CenteredLayout, type CenteredLayoutProps }
